export default new class ModalCookie {

  constructor() {
    this._COOCKIE_NAME  = 'hidecookie';
    this._COOCKIE_AGE   = 86400 * 7;

    this.modal          = '.modal-cookie';
    this.close_button   = '.__grey-button';

    const modal = document.querySelector(this.modal);

    if (!modal) return;

    if (!this._getCookie() && modal && !modal.classList.contains('__show')) {
      document.querySelector(this.modal).classList.add('__show')
    }

    document.querySelector(this.modal).querySelector('.__grey-button').addEventListener('click', (e) => {
      e.preventDefault();
      document.querySelector(this.modal).classList.remove('__show');
      this._setCookie()
    });
  }

  _getCookie() {
    const matches = document.cookie.match(new RegExp("(?:^|; )" + this._COOCKIE_NAME.replace(/([\.$?*|{}\(\)\[\]\\\/\+^])/g, '\\$1') + "=([^;]*)"));
    return matches ? decodeURIComponent(matches[1]) : undefined;
  }

  _setCookie() {
    document.cookie = this._COOCKIE_NAME + '=' + 'true;max-age=' + this._COOCKIE_AGE;
  }
}();
